import { Mail, MapPin, FileText, ShieldCheck, CreditCard, Phone } from "lucide-react";
import { FOOTER, LINKS, IMAGES, NAV_LINKS } from "../../config/landingConfig";
import { scrollToId } from "../../lib/scroll";

export const Footer = () => {
  const go = (e, href) => {
    e.preventDefault();
    scrollToId(href);
  };

  return (
    <footer data-testid="footer" className="border-t-4 border-violet bg-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="grid gap-10 md:grid-cols-[1.2fr_1fr_1fr]">
          <div>
            <a href="#top" data-testid="footer-logo" onClick={(e) => go(e, "#top")} className="flex items-center gap-2">
              {IMAGES.logo ? (
                <img src={IMAGES.logo} alt="Logo Anny Popławskiej" className="h-12 w-auto" />
              ) : (
                <span className="flex items-center gap-2">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl border-2 border-ink bg-magenta shadow-hard-sm">
                    <span className="text-base font-extrabold lowercase leading-none tracking-tight text-white">
                      ap
                    </span>
                  </span>
                  <span className="font-display text-xl uppercase tracking-wide text-ink">AI&nbsp;Speaking&nbsp;Games</span>
                </span>
              )}
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-ink/65">
              AI Speaking Games. Gry, które naprawdę uczą mówić - praktyczny kurs online
              dla nauczycieli języków obcych.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-extrabold uppercase tracking-[0.18em] text-ink/50">Dane firmy</h3>
            <ul className="mt-4 space-y-2.5 text-sm font-semibold text-ink/80">
              <li data-testid="footer-company" className="flex items-start gap-2.5">
                <FileText className="mt-0.5 h-4 w-4 shrink-0 text-magenta" aria-hidden="true" />
                <span>
                  {FOOTER.company}
                  <br />
                  <span className="text-ink/60">
                    KRS: {FOOTER.krs} · NIP: {FOOTER.nip}
                  </span>
                </span>
              </li>
              <li data-testid="footer-address" className="flex items-start gap-2.5">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-magenta" aria-hidden="true" />
                {FOOTER.address}
              </li>
              <li data-testid="footer-email" className="flex items-start gap-2.5">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-magenta" aria-hidden="true" />
                <a href={`mailto:${FOOTER.email}`} className="transition-colors hover:text-magenta">
                  {FOOTER.email}
                </a>
              </li>
              <li data-testid="footer-phone" className="flex items-start gap-2.5">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-magenta" aria-hidden="true" />
                <a href={`tel:${FOOTER.phone.replace(/\s/g, "")}`} className="transition-colors hover:text-magenta">
                  {FOOTER.phone}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-extrabold uppercase tracking-[0.18em] text-ink/50">Informacje</h3>
            <ul className="mt-4 space-y-2.5 text-sm font-semibold">
              <li>
                <a
                  href={LINKS.privacy}
                  data-testid="footer-link-privacy"
                  className="inline-flex items-center gap-2.5 text-ink/80 transition-colors hover:text-magenta"
                >
                  <ShieldCheck className="h-4 w-4 shrink-0 text-cyan" aria-hidden="true" />
                  Polityka prywatności
                </a>
              </li>
              <li>
                <a
                  href={LINKS.terms}
                  data-testid="footer-link-terms"
                  className="inline-flex items-center gap-2.5 text-ink/80 transition-colors hover:text-magenta"
                >
                  <FileText className="h-4 w-4 shrink-0 text-cyan" aria-hidden="true" />
                  Regulamin
                </a>
              </li>
              <li>
                <a
                  href={LINKS.payments}
                  data-testid="footer-link-payments"
                  className="inline-flex items-center gap-2.5 text-ink/80 transition-colors hover:text-magenta"
                >
                  <CreditCard className="h-4 w-4 shrink-0 text-cyan" aria-hidden="true" />
                  Informacje o płatnościach
                </a>
              </li>
            </ul>
            <nav className="mt-6 flex flex-wrap gap-x-4 gap-y-2" aria-label="Menu w stopce">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  data-testid={`footer-nav-${link.href.slice(1)}`}
                  onClick={(e) => go(e, link.href)}
                  className="text-xs font-bold text-ink/55 transition-colors hover:text-magenta"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-12 border-t-2 border-ink/15 pb-16 pt-6 md:pb-0">
          <p data-testid="footer-copyright" className="text-center text-xs font-semibold text-ink/50">
            {FOOTER.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};
